import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import { Nav } from "./components/landing/Nav";
import { Hero } from "./components/landing/Hero";
import { Symptoms } from "./components/landing/Symptoms";
import { Treatment } from "./components/landing/Treatment";
import { Conditions } from "./components/landing/Conditions";
import { About } from "./components/landing/About";
import { Testimonials } from "./components/landing/Testimonials";
import { Faq } from "./components/landing/Faq";
import { FinalCta } from "./components/landing/FinalCta";
import { Footer } from "./components/landing/Footer";
import { WhatsAppFloat } from "./components/landing/WhatsAppFloat";
import SpecialtyPage from "./pages/SpecialtyPage";
import { Helmet } from "react-helmet-async";

// Scrolls to hash element on route change / initial load

const HashScroller = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      // wait one frame for the section to be mounted
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 60);
      return () => clearTimeout(t);
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [pathname, hash]);
  return null;
};

const Landing = () => {
  return (
    <div data-testid="landing-page" className="bg-white text-[#1A1A1A]">
      <Helmet>
  <title>
    Dra. Luz Adriana | Especialista em Toxina Botulínica Terapêutica
  </title>

  <meta
    name="description"
    content="Atendimento especializado para reabilitação neurológica com a Dra. Luz Adriana."
  />

  <link
    rel="canonical"
    href="https://draluzadriana.com.br/"
  />

  <meta property="og:type" content="website" />

  <meta
    property="og:title"
    content="Dra. Luz Adriana | AVC, Distonia e Espasticidade"
  />

  <meta
    property="og:description"
    content="Atendimento especializado para reabilitação neurológica com a Dra. Luz Adriana."
  />

  <meta
    property="og:url"
    content="https://draluzadriana.com.br/"
  />
  
  <script type="application/ld+json">
  {JSON.stringify({
    "@context": "https://schema.org",
    "@type": "IndividualPhysician",
    name: "Dra. Luz Adriana",
    url: "https://draluzadriana.com.br/",
    image: "https://draluzadriana.com.br/dra-luz-adriana-google.jpeg",
    description:
      "Médica fisiatra com atuação em reabilitação neurológica e tratamento de enxaqueca, distonia e espasticidade com toxina botulínica terapêutica.",
    medicalSpecialty: [
      "PhysicalMedicine",
      "Neurologic"
    ],
    knowsAbout: [
      "Enxaqueca",
      "Distonia",
      "Espasticidade",
      "Reabilitação neurológica",
      "Toxina botulínica terapêutica"
    ]
  })}
  </script>
</Helmet>
      <Nav />
      <main>
        <Hero />
        <Conditions />
        <Symptoms />
        <Treatment />
        <About />
        <Testimonials />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <HashScroller />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/especialidades/:slug" element={<SpecialtyPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
